import axios from 'axios'
const $axios = axios.create({
  baseURL: `${process.env.VUE_APP_HOST}`
})
$axios.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    return config
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return Promise.resolve(response)
}, error => {
  if (error.response.status !== 401) {
    return Promise.reject(error)
  }

  window.localStorage.clear()
  window.location.reload()
})

export const http = $axios
